// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d185b2a6","667":"83d1b56b"}[chunkId] + ".chunk.js";
};